"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defineKzg = defineKzg;
function defineKzg({ blobToKzgCommitment, computeBlobKzgProof, }) {
    return {
        blobToKzgCommitment,
        computeBlobKzgProof,
    };
}
//# sourceMappingURL=defineKzg.js.map